import { render, staticRenderFns } from "./ProcedureStages.vue?vue&type=template&id=6a751312&scoped=true&"
import script from "./ProcedureStages.vue?vue&type=script&lang=js&"
export * from "./ProcedureStages.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureStages.vue?vue&type=style&index=0&id=6a751312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a751312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDialog,VDivider,VSimpleTable})
